import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const ScrollLink = ({ to, children }) => (
  <Link to={to} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
    {children}
  </Link>
);

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <h3>Seminexis</h3>
          <p>Powering India's semiconductor revolution with precision silicon wafers.</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><ScrollLink to="/">Home</ScrollLink></li>
            <li><ScrollLink to="/about">About</ScrollLink></li>
            <li><ScrollLink to="/products">Products</ScrollLink></li>
            <li><ScrollLink to="/contact">Contact</ScrollLink></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>📧 <a href="mailto:darshanpawar18@gmail.com">darshanpawar18@gmail.com</a></p>
          <p>📞 <a href="tel:2692766645">269-276-6645</a></p>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/darshan-pawar-4369bb108/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                <circle cx="4" cy="4" r="2"/>
              </svg>
              LinkedIn
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
              </svg>
              Twitter
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Seminexis Pvt Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
